module.exports = __webpack_public_path__ + "img/dao.f56af770.png";